import { z } from 'zod';

import { request } from '@/api/httpClient';

export type DefinitionKind = 'readings' | 'dosages';
export interface Definition {
  id: number;
  name: string;
  unit: string;
  min: number;
  max: number;
  step: number;
}
export type DefinitionInput = Omit<Definition, 'id'>;

const schema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  unit_of_measurement: z.string().min(1),
  min: z.coerce.number(),
  max: z.coerce.number(),
  step: z.coerce.number(),
});
const body = (value: DefinitionInput) => ({
  name: value.name,
  unit_of_measurement: value.unit,
  min: value.min,
  max: value.max,
  step: value.step,
});
const map = (value: z.infer<typeof schema>): Definition => ({
  id: value.id,
  name: value.name,
  unit: value.unit_of_measurement,
  min: value.min,
  max: value.max,
  step: value.step,
});

export async function getDefinitions(kind: DefinitionKind) {
  return z
    .array(schema)
    .parse(await request<unknown>(`/managers/settings/${kind}`))
    .map(map);
}
export async function saveDefinition(kind: DefinitionKind, value: DefinitionInput, id?: number) {
  return map(schema.parse(await request<unknown>(`/managers/settings/${kind}${id ? `/${id}` : ''}`, {
    method: id ? 'PUT' : 'POST',
    body: body(value),
  })));
}
export async function deleteDefinition(kind: DefinitionKind, id: number) {
  await request(`/managers/settings/${kind}/${id}`, { method: 'DELETE' });
}
